package org.bsvac.bsvac_kmp

import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.sp
import androidx.lifecycle.ViewModel
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import org.bsvac.bsvac_kmp.data.BsvacTextStyle
import org.bsvac.bsvac_kmp.data.models.ContentSectionId
import org.bsvac.bsvac_kmp.data.fakeData.DataSource
import org.bsvac.bsvac_kmp.data.TimeSource
import org.bsvac.bsvac_kmp.data.models.AgencyModel
import org.bsvac.bsvac_kmp.data.models.AmbulanceUnitModel
import org.bsvac.bsvac_kmp.data.models.BoroughModel
import org.bsvac.bsvac_kmp.data.models.CrewModel
import org.bsvac.bsvac_kmp.data.models.LogonOptionModel
import org.bsvac.bsvac_kmp.data.models.RadioModel
import org.bsvac.bsvac_kmp.data.models.TourModel
import org.bsvac.bsvac_kmp.ui.models.Selected


class MainViewModel: ViewModel() {

    private val scope = CoroutineScope(Dispatchers.Main + SupervisorJob())

    private val timeSource = TimeSource()
    private val timeJob = scope.launch {
        while(true) {
            _timeFlow.value = timeSource.timeString
            delay(1000)
        }
    }

    private val _logonOptionSet = MutableStateFlow(LogonOptionModel.EMPTY)
    val logonOptionSet: StateFlow<LogonOptionModel> = _logonOptionSet

    fun onAgencySelected(agency: AgencyModel) {
        _logonOptionSet.value = LogonOptionModel (
            boroughOptions = BoroughModel.validEntries(selectedAgency = agency),
            crewOptions = CrewModel.validEntries(selectedAgency = agency),
            unitOptions = AmbulanceUnitModel.validEntries(selectedAgency = agency),
            tourOptions = TourModel.validEntries(selectedAgency = agency),
            radioOptions = RadioModel.validEntries(selectedAgency = agency)
        )
        _selectedState.value = Selected(agency = agency)
    }

    fun onNavigationClicked(contentSectionId: ContentSectionId) {
        _subscreenDisplayed.value = contentSectionId
    }

    fun onActionClicked(contentSectionId: ContentSectionId) {
        _subscreenDisplayed.value.onActionClicked(contentSectionId, this)
    }

    fun displayErrorMessage(string: String) {
        _errorMessage.value = string
        scope.launch {
            delay(DataSource.ErrorDialogTimeoutMs())
            _errorMessage.value = null
        }
    }

    fun  errorDisplayed() {}
    fun setFontSize(updatedSize: TextUnit) {
        _textStyle.value = _textStyle.value.copy(fontSize = updatedSize)
    }

    fun onCrewMemberSelected(crewPosition: Int, crewMember: CrewModel){
        val updateLambdas = listOf(
            { _selectedState.value = _selectedState.value.copy(crewMember1 = crewMember) },
            { _selectedState.value = _selectedState.value.copy(crewMember2 = crewMember) },
            { _selectedState.value = _selectedState.value.copy(crewMember3 = crewMember) },
            { _selectedState.value = _selectedState.value.copy(crewMember4 = crewMember) },
        )
        if (crewPosition-1 > updateLambdas.size) {
            return
        }
        updateLambdas[crewPosition-1]()
        updateLogonOptions()

    }

    private fun updateLogonOptions() {
        val currentOptions = _logonOptionSet.value
        val currentAgency = _selectedState.value.agency
        val selectedRadios = listOfNotNull(
            _selectedState.value.radio1,
            _selectedState.value.radio2,
            _selectedState.value.radio3,
            _selectedState.value.radio4
        )
        val selectedCrew = listOfNotNull(
            _selectedState.value.crewMember1,
            _selectedState.value.crewMember2,
            _selectedState.value.crewMember3,
            _selectedState.value.crewMember4,
            )
        val newOptions = currentOptions.copy(
            radioOptions = RadioModel.validEntries(selectedAgency = currentAgency).filterNot { selectedRadios.contains(it) },
            crewOptions = CrewModel.validEntries(selectedAgency = currentAgency).filterNot { selectedCrew.contains(it) }
        )
        _logonOptionSet.value = newOptions
    }

    fun  onBoroughSelected(borough: BoroughModel){
        _selectedState.value = _selectedState.value.copy(borough = borough)
    }
    fun onAmbulanceUnitSelected(unit: AmbulanceUnitModel){
        _selectedState.value = _selectedState.value.copy(unit = unit)
    }
    fun onTourSelected(tour: TourModel){
        _selectedState.value = _selectedState.value.copy(tour = tour)
    }
    fun onRadioSelected(radioPosition: Int, radio: RadioModel){
        val updateLambdas = listOf(
            { _selectedState.value = _selectedState.value.copy(radio1 = radio) },
            { _selectedState.value = _selectedState.value.copy(radio2 = radio) },
            { _selectedState.value = _selectedState.value.copy(radio3 = radio) },
            { _selectedState.value = _selectedState.value.copy(radio4 = radio) },
        )
        if (radioPosition-1 > updateLambdas.size) {
            return
        }
        updateLambdas[radioPosition-1]()
        updateLogonOptions()
    }

    private val _errorMessage = MutableStateFlow<String?>(null)
    val errorMessage : StateFlow<String?> = _errorMessage.asStateFlow()

    private val _selectedState = MutableStateFlow(Selected())
    val selectedState: StateFlow<Selected> = _selectedState


    private val _uiState = MutableStateFlow(MainUiState.Loading)
    val uiState: StateFlow<MainUiState> = _uiState.asStateFlow()

    private val _subscreenDisplayed = MutableStateFlow(ContentSectionId.LOGON)
    val subscreenState: StateFlow<ContentSectionId> = _subscreenDisplayed.asStateFlow()

    private val _timeFlow = MutableStateFlow(timeSource.timeString)
    val timeFlow: StateFlow<String> = _timeFlow

    private val _textStyle = MutableStateFlow(BsvacTextStyle(15.sp))
    val textStyle: StateFlow<BsvacTextStyle> = _textStyle
}